import { render, staticRenderFns } from "./PayGate.vue?vue&type=template&id=005f5004"
import script from "./PayGate.vue?vue&type=script&lang=js"
export * from "./PayGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports